import AppStory15Game from "./AppStory15Game";

export default AppStory15Game;
